<template>
  <v-app>
    <div class="animated fadeIn">

      <ddoWaiting :value="loading" color="primary" :message="$t('texts.loading')"/>

      <ddoSelectSwitchCustomer ref="mySelect"
          @switchCustomer="refresh_page"
      >
      </ddoSelectSwitchCustomer>

      <ddoClientList ref="mainTable" :loading="loading" :level="levels[0]" 
          :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
          :customSlotNames="levels[0].customSlotNames"
          @loading="refresh_loading"
          @childKey="refresh_childKey"
          @row="refresh_row"
          @errors="refresh_errors"
          >

         <template v-slot:superheader="{ errors }">
            <h1>{{ $t('titles.ldc') }}</h1>
         </template>

         <template v-slot:header="{ errors }">
            <v-row>
               <v-col sm="6">
                  <v-btn :disabled="buttonAttachPLF" @click="$refs.mainTable.load_for_create()" rounded class="primary">
                     <v-icon>mdi-plus-circle</v-icon>{{ $t('buttons.create_ldapconnector') }}
                  </v-btn>
               </v-col>
               <v-col sm="6">
                  <ddoSelectPlatform :callbacks="PLFcallbacks" ref="mySelectPLF" :options="PLFoptions"/>
               </v-col>
            </v-row>
         </template>

         <template v-slot:dialogform="{ row, level }">
            <CardUpdatableLdapConnector ref="myConnector" :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
               @errors="refresh_errors"
               @change_dialogValues="change_dialogValues"
            />
         </template>

         <template slot="xxx_connector_name" slot-scope="props">
            <span v-if="props.row.xxx_dyn_connector_name!=null">{{ props.row.xxx_dyn_connector_name }}</span>
            <span v-else>{{ props.row.plf_name }}</span>
         </template>

        <template v-slot:child_row="{ props }">
          <ddoClientListTreeviewLDAP ref="myLDAPTree" :loading="loading" :level="levels[1]" :callbacks="levels[1].callbacks" :options="levels[1].options"
            @loading="refresh_loading"
            @childKey="refresh_childKey"
            @selectActive="select_active"
            @errors="refresh_errors"
          >

            <template v-slot:prepend="{ item, active }">
               <v-icon v-if="item.is_root">mdi-home</v-icon>
               <v-icon v-else-if="item.is_ou">mdi-folder</v-icon>
               <v-icon v-else-if="item.is_user">mdi-account</v-icon>
               <v-icon v-else-if="item.is_group">mdi-account-multiple</v-icon>
               <v-icon v-else-if="item.is_contact">mdi-account-outline</v-icon>
               <v-icon v-else>mdi-comment-question-outline</v-icon>
            </template>

            <template v-slot:label="{ item, active }">
               {{ item.name }}<span v-if="item.displayname"> ({{item.displayname}})</span>
            </template>

            <!-- We use 'v-on:click.stop=', instead of '@click.native=' to avoid propagation of 'click' event to slot 'label', corresponding to 'activatable' propery of the v-treeview -->
            <template v-slot:append="{ item, active }">
               <v-icon v-if="item.is_ou||item.is_root" v-on:click.stop="ask_create_item(item)">mdi-plus-circle-outline</v-icon>
               <v-icon v-if="!item.is_root" v-on:click.stop="ask_delete_item(item)">mdi-minus-circle-outline</v-icon>
               <v-icon v-if="item.is_ou||item.is_root" v-on:click.stop="ask_refresh_item(item)">mdi-refresh</v-icon>
            </template>

            <template v-slot:superheader="slotProps">
              <h2>{{ $api._format($t('subtitles.lde'),(slotProps.parentToggledRow['xxx_dyn_connector_name']!=null ? slotProps.parentToggledRow['xxx_connector_name'] : slotProps.parentToggledRow['plf_name'] ) ) }}</h2>
            </template>

            <template v-slot:dialogform="{ row, level }" v-scroll:#scroll-target="onScroll">
               <CardUpdatableLdapEntry ref="myEntry" :row="levels[1].row" :depth="levels[1].level" :level="levels[1]"
                  @errors="refresh_errors"
                  @changeSelectLDT="changeSelectLDT"
                  @change_dialogValues="change_dialogValues"
               />
            </template>

          </ddoClientListTreeviewLDAP>
        </template>

     </ddoClientList>

    </div>
  </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import ddoWaiting from '@/components/ddoWaiting.vue'
import ddoSelectSwitchCustomer from '@/components/ddoSelectSwitchCustomer.vue'
import ddoClientList from '@/components/ddoClientList.vue';
import ddoClientListTreeviewLDAP from '@/components/ddoClientListTreeviewLDAP.vue';
import ddoSelectPlatform from '@/components/ddoSelectPlatform.vue'

import CardUpdatableLdapConnector from '@/components/partials/CardUpdatableLdapConnector.vue';
import CardUpdatableLdapEntry from '@/components/partials/CardUpdatableLdapEntry.vue';

import VueSticky from 'vue-sticky';

import * as util from 'util'

let initial_row = {}

export default {
   name: 'ldapentry',
   components: {
      ddoAlert,
      ddoWaiting,
      ddoSelectSwitchCustomer,
      ddoClientList,
      ddoClientListTreeviewLDAP,
      CardUpdatableLdapConnector,
      CardUpdatableLdapEntry,
      ddoSelectPlatform,
   },
   directives: {
         'sticky': VueSticky,
   },
   data: () => {
      return {
         _this: null,
         loading: false,
         emptyItem: { _pk: -1, name: "", code: "", children: [] },

         selectedPLF: null,
         buttonAttachPLF: true,
         PLFcallbacks: {},
         PLFoptions: {
            initial: null,
            selected: null,
            required: true,
            disabled: false,
            multiple: false,
            clearable: false,
            item_text: "plf_name",
            item_value: "plf_pk",
            item_disabled: "",
            hide_selected: true,
            label: i18n.t('texts.platform'),
         },
         PLFdialogOptions: {
            cus_code: null,
            cus_name: null,
            plf_is_auth: false,
            plf_is_dynamic: false,
            plf_exchangelike: false,
            plf_citrixlike: false,
            plf_ws_url_base: null,
            plf_domain_radix: null,
         },

         /* 
         * SELECTS : callbacks, ...
         */
         selects: [],

         /* 
         * LEVEL 1 : all for ddoClientList : columns, options, callbacks
         */
         levels: [

            {
               api_code: 'ldapconnector',
               api_prefix: 'ldc',
               row: {},
               level: 0,
               errors: [],
               columns: [ '_actions', 'plf_code', 'xxx_connector_name'],
               customSlotNames: ['xxx_connector_name'],
               options: {
                  showChildRowToggler: false,
                  withChild: true,
                  hiddenColumns: [],
                  headings: {
                     _child: i18n.t('headers.actions'),
                     _pk: i18n.t('headers.actions'),
                     cus_plf_pk: '#',
                     plf_code: i18n.t('headers.code'),
                     plf_name: i18n.t('headers.name'),
                     xxx_connector_name: i18n.t('headers.xxx_connector_name'),
                     _update: i18n.t('headers.updated_on')
                  },
                  texts: {
                  },
                  uniqueKey: 'cus_plf_pk',
                  sortable: [],
                  filterable: false,
                  sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                  columnsDropdown: false,
                  pagination: {
                     chunk: 5,
                     edge: false,
                     nav: 'scroll'
                  },
               },
               callbacks: {
               },
               dialogOptions: {
                  codeRules : [
                     (v) => !!v || i18n.t('texts._required')
                  ],
               },
               dialogValues: {
                  headers: {
                     create: i18n.t('texts.ldc_create_title'),
                     update: i18n.t('texts.ldc_update_title'),
                     delete: i18n.t('texts.ldc_delete_title'),
                  },
                  dialogShow: false,
                  form_disabled: false,
                  form_close: true,
                  form_create: false,
                  form_update: false,
                  form_delete: false,
                  disable_create: false,
                  disable_update: false,
                  disable_delete: false,
                  header_value_function: function(row) { return row['plf_code']; },
                  plf_minimal_root_path: null,
               },
               customer: {},
            },

            {
               api_code: 'ldapentry',
               api_prefix: 'lde',
               // We need to declare the is_* properties, because they need to be observable
               //row: { is_user: false, is_ou: false, is_group: false, is_contact: false, is_root: false },
               row: {},
               level: 1,
               errors: [],
               columns: [],
               options: {
                  return_object: true,
                  selectable: false,
                  activatable: true,
                  width_tree: 4,
                  width_form: 7,
               },
               callbacks: {
               },
               dialogOptions: {
                  codeRules : [
                     (v) => !!v || i18n.t('texts._required')
                  ],
                  emailRules : [
                     (v) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,24})+$/.test(v) || i18n.t('texts._email_format'),
                  ],
               },
               dialogValues: {
                  headers: {
                     create: i18n.t('texts.lde_create_title'),
                     update: i18n.t('texts.lde_update_title'),
                     delete: i18n.t('texts.lde_delete_title'),
                  },
                  dialogShow: false,
                  form_disabled: false,
                  form_close: true,
                  form_create: false,
                  form_update: false,
                  form_delete: false,
                  disable_create: true,
                  disable_update: false,
                  disable_delete: false,
                  header_value_function: function(row) { return row['name']; },
               },
               current_active: null,
            },

         ],

         items: [ { _pk: 0, name: "<root>", code: "saas.ddo.net/Hosting/ddo", children: [] } ],

         dict : {
            displayname: 'lde_displayname',
            userprincipalname: 'lde_userprincipalname',
            distinguishedname: 'lde_distinguishedname',
            samaccountname: 'lde_samaccountname',
            password: 'usr_password',
            givenname: 'lde_givenname',
            name: 'lde_name',
            code: 'lde_path',
            sn: 'lde_sn',
            mail: 'lde_mail',
            cn: 'lde_cn',
            useraccountcontrol: 'lde_useraccountcontrol',
         },

         model: {},
         dialogShow: false,
         dialogId: null,
         dialogcode: null,

         useVuex: false,
         theme: 'bootstrap4',
         template: 'default',
      }
   },

   created() {
      this._this = this;

      this.levels[0].callbacks.prepare_create = this.prepare_create_l1;    
      this.levels[0].callbacks.prepare_update = this.prepare_update_l1;    
      this.levels[0].callbacks.prepare_delete = this.prepare_delete_l1;    
      this.levels[0].callbacks.configure_form = this.configure_form;
      this.levels[0].callbacks.show_dialog    = this.show_dialog;
      this.levels[0].callbacks.refresh_errors = this.refresh_errors;
      this.levels[0].callbacks.after_create_row = this.after_create_row_l1;
      this.levels[0].callbacks.after_delete_row = this.after_delete_row_l1;

      this.levels[1].dialogValues.dialogShow  = false;
      this.levels[1].callbacks.refresh_rows   = this.refresh_rows_l2;
      this.levels[1].callbacks.prepare_create = this.prepare_create_l2;    
      this.levels[1].callbacks.prepare_update = this.prepare_update_l2;    
      this.levels[1].callbacks.create_row     = this.create_row_l2;    
      this.levels[1].callbacks.update_row     = this.update_row_l2;    
      this.levels[1].callbacks.delete_row     = this.delete_row_l2;    
      this.levels[1].callbacks.configure_form = this.configure_form;
      this.levels[1].callbacks.show_dialog    = this.show_dialog;
      this.levels[1].callbacks.refresh_errors = this.refresh_errors;
      this.levels[1].callbacks.check_skip_confirm = this.check_skip_confirm;

      this.PLFcallbacks.refresh_rows = this.build_select_plf;
      this.PLFcallbacks.change       = this.change_plf;
   },

   async mounted() {
      this.refresh_session();
   },

  methods: {

      async build_select_plf(key=null) {
         this.loading = true;
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'ldapplatform');
         this.loading = false;
         //console.log('build_select_plf, api_response='+JSON.stringify(api_response))
         return { errorinfos, api_response }
      },

      async change_plf(value,item=null) {
         //console.log('change_plf, value='+value+', item='+JSON.stringify(item));
         if ( value!=null ) {
            this.buttonAttachPLF = false;
            this.selectedPLF = value;
         }
         this.buttonAttachPLF = ( value==null ? true : false);
      },

      clickOn(data) {
         //console.log('clickOn, data='+JSON.stringify(data));
         this.$refs.mySelect.remove(data.item);
      },

      refresh_loading(value) {
         this.loading = value;
      },

      refresh_errors(level,errors) {
         this.levels[level].errors = errors;
      },

      refresh_row(level,row) {
         this.levels[level].row = row;
      },

      async refresh_session() {
         var { errorinfos, api_response } = await this.$api._get_session(this.$router);
         if ( api_response.error==0 && api_response.row ) {
            this.levels[0].customer = { cus_pk: api_response.row.cus_pk_customer, cus_code: api_response.row.cus_code_selected, cus_name: api_response.row.cus_name_selected };
            this.levels[0].row.cus_pk = api_response.row.cus_pk_customer;
         }
      },

      changeSelectLDT(value,item) {
         if ( item!=null ) {
            this.levels[1].row.is_ou      = item.ldt_is_ou;
            this.levels[1].row.is_group   = item.ldt_is_group;
            this.levels[1].row.is_user    = item.ldt_is_user;
            this.levels[1].row.is_contact = item.ldt_is_contact;
            this.levels[1].row.is_root    = false;
         }
         console.log('changeSelectLDT, final row='+JSON.stringify(this.levels[1].row))
      },

      select_active(values,currentItem) {
         if ( Array.isArray(values) && values.length>0 ) {
            this.levels[1].row = JSON.parse(JSON.stringify(currentItem));
            //this.levels[1].row = currentItem;
            if ( this.levels[1].row.is_root ) {
               this.levels[1].row.is_ou      = false;
               this.levels[1].row.is_group   = false;
               this.levels[1].row.is_user    = false;
               this.levels[1].row.is_contact = false;
            }
            this.levels[1].errors = [];
            this.levels[1].dialogValues.dialogShow     = true;
            //this.levels[1].dialogValues.disable_update = false;
            //this.levels[1].dialogValues.form_update    = true;

            this.configure_form(1,false,false,true,false);
            this.show_dialog(1,true);
         }
      },

      async refresh_page() {
         console.log('refresh_page');
         this.refresh_session();
         //this.levels[0].session_row = ses_row;
         await this.$refs.mainTable.refresh_rows(null);
         await this.$refs.mySelectPLF.refresh_rows();
         //await this.$refs.myConnector.refresh_select_plf(null);
      },

      async ask_create_item(parentItem) {
         var item =  JSON.parse(JSON.stringify(this.emptyItem));
         item._pk = null;
         item.code = parentItem.code;
         item.parent = parentItem;
         this.$refs.myEntry.clear_selectLDT();
         if ( item._pk==null ) {
            this.levels[1].errors = [];
            this.levels[1].row = JSON.parse(JSON.stringify(item));
            this.configure_form(1,false,true,false,false);
            this.show_dialog(1,true);
         }
      },

      async ask_delete_item(item) {
         if ( item._pk ) {
            this.levels[1].row = JSON.parse(JSON.stringify(item));
            this.levels[1].errors = [];
            this.configure_form(1,true,false,false,true);
            this.show_dialog(1,true);
         }
      },

      async ask_refresh_item(item) {
         item.children = [];
         this.$refs.myLDAPTree.refresh_rows(item);
      },

      async refresh_rows_l2(item) {
         this.loading = true;
         let _parentKey = this.levels[1].childKey;
         let { errorinfos, api_response } = await this.$api.getRows(this.$router,this.levels[0].api_code+'/'+_parentKey+'/entries?lde_code='+item.code);
         this.loading = false;
         return { errorinfos, api_response }
      },

      refresh_childKey(level,key,toggledRow=null) {
         this.levels[level].childKey = key;
         this.levels[level].toggledRow = toggledRow;
      },

      configure_form(level,f_disabled,f_create,f_update,f_delete) {
         let _dV = this.levels[level].dialogValues;
         _dV.form_disabled = f_disabled;
         _dV.form_create   = f_create;
         _dV.form_update   = f_update;
         _dV.form_delete   = f_delete;
         this.levels[level].dialogValues = _dV;
      },

      adapt_row_with_dict(row) {
         //console.log('AVANT, row='+JSON.stringify(row));
         for ( var property in row ) {
            if ( this.dict[property] ) {
               row[this.dict[property]] = row[property];
               delete row[property];
            }
         }
         //console.log('APRES, row='+JSON.stringify(row));
      },

      async prepare_update_l2(row) {
         this.levels[1].errors = [];
      },

      async create_row_l2(router,api_code,row) {
         console.log('create_row_l2, initial row='+JSON.stringify(row))
         var restructured_row = JSON.parse(JSON.stringify(row));
         this.adapt_row_with_dict(restructured_row);
         if ( row ) {
            restructured_row.ldt_is_ou      = row.is_ou;
            restructured_row.ldt_is_group   = row.is_group;
            restructured_row.ldt_is_user    = row.is_user;
            restructured_row.ldt_is_contact = row.is_contact;
            // REQUIRED : to create a LDAP entry, we need to know the context, and the context (rl_cus_plf) is given by the current childKey of level 1
            if ( this.levels[1].childKey ) {
               restructured_row.cus_plf_pk = this.levels[1].childKey;
            }
            // We drop _pk, children and parent properties. No need
            delete restructured_row._pk;
            delete restructured_row.children;
            delete restructured_row.parent;
         }

         var { errorinfos, api_response } = await this.$api.createRow(router,api_code,restructured_row);
         this.levels[0].errors = [ errorinfos ];
         // We refresh the parent :
         if ( row.parent && row.parent._pk>=0 ) {
            var _parent = this.$refs.myLDAPTree.find_item_by_key(row.parent._pk);
            if ( _parent ) {
               await this.$refs.myLDAPTree.refresh_rows(_parent);
            }
         }
         return { errorinfos, api_response }
      },

      async update_row_l2(router,api_code,_pk,row) {
         var restructured_row = JSON.parse(JSON.stringify(row));
         if ( _pk==null ) { // and undefined
            _pk = restructured_row._pk;
         }
         this.adapt_row_with_dict(restructured_row);
         var { errorinfos, api_response } = await this.$api.updateRow(router,api_code,_pk,restructured_row);
         if ( api_response.error==0 ) {
            this.levels[1].errors = [ errorinfos ];
         }
         if ( api_response.error==0 ) {
            let { errorinfos: errorinfos2, api_response: api_response2 } = await this.$api.getRow(router,api_code,_pk);
            let newrow = api_response2.row;
            this.$refs.myLDAPTree.update_current_row(newrow);
         }
         return { errorinfos, api_response }
      },

      async delete_row_l2(router,api_code,_pk,row) {
         var restructured_row = JSON.parse(JSON.stringify(row));
         if ( _pk==null ) { // and undefined
            _pk = restructured_row._pk;
         }
         var { errorinfos, api_response } = await this.$api.deleteRow(router,api_code,_pk);
         this.levels[1].errors = [ errorinfos ];
         if ( api_response.error==0 ) {
            this.$refs.myLDAPTree.delete_current_row(row);
         }
         return { errorinfos, api_response }
      },

      show_dialog(level,show) {
         //console.log('show_dialog, level='+level+', show='+show)
         let _dV = this.levels[level].dialogValues;
         _dV.header_value = _dV.header_value_function(this.levels[level].row);
         _dV.dialogShow   = show;
         this.levels[level].dialogValues = _dV;
      },

      prepare_create_l1(parentKey=null) {
         console.log('IN prepare_create_l1, START');
         this.$refs.myConnector.PLFoptions.disabled = true;
         this.$refs.myConnector.PLFoptions.selected = this.selectedPLF;
         this.levels[0].row = { plf_pk: this.selectedPLF, cus_pk: this.levels[0].row.cus_pk }
         if ( this.selectedPLF!=null ) {
            var _item = this.$api._get_by_pk( this.$refs.mySelectPLF.items, this.selectedPLF);
            this.levels[0].dialogValues.plf_minimal_root_path = _item.plf_minimal_root_path;
            this.levels[0].row.xxx_ad_org_unit = _item.plf_minimal_root_path;
            console.log('IN prepare_create_l1, _item='+JSON.stringify(_item));
            this.$refs.myConnector.change(this.selectedPLF,_item);
         }
         this.levels[0].errors = [];
         console.log('IN prepare_create_l1, END');
      },

      prepare_update_l1(parentKey=null) {
         console.log('IN prepare_update_l1, START, row='+JSON.stringify(this.levels[0].row));
         this.$refs.myConnector.PLFdialogOptions.plf_is_auth    = this.levels[0].row.plf_is_auth;
         this.$refs.myConnector.PLFdialogOptions.plf_is_dynamic = this.levels[0].row.plf_is_dynamic;
         this.levels[0].dialogValues.plf_minimal_root_path      = this.levels[0].row.plf_minimal_root_path;
         this.levels[0].errors = [];
         console.log('IN prepare_update_l1, END');
      },

      prepare_delete_l1(parentKey=null) {
         //console.log('IN prepare_update_l1, level(0).row='+JSON.stringify(this.levels[0].row));
         this.$refs.myConnector.PLFdialogOptions.plf_is_auth    = this.levels[0].row.plf_is_auth;
         this.$refs.myConnector.PLFdialogOptions.plf_is_dynamic = this.levels[0].row.plf_is_dynamic;
         this.levels[0].dialogValues.plf_minimal_root_path      = this.levels[0].row.plf_minimal_root_path;
         this.levels[0].errors = [];
      },

      /*
       * Refresh the PLF dropdown, because list of available platforms may have changed, after an insert of one of them
       */
      async after_create_row_l1(level,errorinfos,api_response) {
         console.log('IN after_create_row_l1, BEGIN');
         if ( api_response.error==0 ) {
            console.log('IN after_create_row_l1, in IF');
            this.$refs.mySelectPLF.initial = null;
            this.$refs.mySelectPLF.selected = null;
            await this.$refs.mySelectPLF.refresh_rows();
         }
       },

      /*
       * Refresh the PLF dropdown, because list of available platforms may have changed, after a delete of one of them
       */
      async after_delete_row_l1(level,errorinfos,api_response) {
         console.log('IN after_delete_row_l1, BEGIN');
         if ( api_response.error==0 ) {
            this.$refs.mySelectPLF.selected = null;
            await this.$refs.mySelectPLF.refresh_rows();
         }
       },

      change_dialogValues(level,property,value) {
         this.levels[level].dialogValues[property] = value;
      },

      check_skip_confirm(method,row) {
         var check = false;
         switch (method) {
            case 'create':
            case 'update':
               check = false;
               break;
            case 'delete':
               check = false;
               break;
         }
         return check;
      },

   },

}
</script>